module.exports = __webpack_public_path__ + "img/AXA LOGO TRANPARENT.109ed4d2.png";